module.exports = __webpack_public_path__ + "static/media/apartment1a.8c3c31a4.jpg";